@let selectedBudgetType = (selectedBudgetType$ | async);
<app-overlay-scrollbar #spendTableWrapper>
  <div

    cdkDropListOrientation="vertical"
    cdkDropListLockAxis="y"
    cdkDropList
    class="data-wrapper"
    [ngClass]="{
    'cursor-grab': isDragging,
    'lines-vertical-spacing':
      selectedBudgetType === SPEND_TYPES.BUDGET ||
      selectedBudgetType === SPEND_TYPES.BUDGET_PARENT_ONLY ||
      selectedBudgetType === SPEND_TYPES.PRIME_CONTRACT_PARENT_ONLY
  }"
    (cdkDropListDropped)="dropLineItem($event)"
  >
    <app-budget-line-item-table-header
      [selectedBudgetType]="selectedBudgetType"
    ></app-budget-line-item-table-header>

    <div
      [ngClass]="{
      'is-commitments': [
        SPEND_TYPES.BUDGET_COMMITMENTS,
        SPEND_TYPES.BUDGET_COMMITMENTS_GC,
        SPEND_TYPES.COMMITMENTS
      ].includes(selectedBudgetType),
      'hidden': !items.length && !isLoading()
    }"
      class="vertical-line first"
    ></div>
    <div
      [ngClass]="{
      'is-commitments': [
        SPEND_TYPES.BUDGET_COMMITMENTS,
        SPEND_TYPES.BUDGET_COMMITMENTS_GC,
        SPEND_TYPES.COMMITMENTS
      ].includes(selectedBudgetType),
      'hidden': !items.length && !isLoading()
    }"
      class="vertical-line second"
    ></div>
    <div
      [ngClass]="{
      'is-commitments': [
        SPEND_TYPES.BUDGET_COMMITMENTS,
        SPEND_TYPES.BUDGET_COMMITMENTS_GC,
        SPEND_TYPES.COMMITMENTS
      ].includes(selectedBudgetType),
      'hidden': !items.length && !isLoading()
    }"
      class="vertical-line third"
      [style]="{
      height: thirdLineHeight() + 'px'
    }"
    ></div>

    @if (selectedBudgetType === SPEND_TYPES.BUDGET ||
    selectedBudgetType === SPEND_TYPES.BUDGET_PARENT_ONLY ||
    selectedBudgetType === SPEND_TYPES.BUDGET_PARENT_CHILD ||
    selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS ||
    selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS_GC) {
      @for (item of items; track item.id) {
        <div
          cdkDrag
          (cdkDragStarted)="isDragging = true"
          (cdkDragEnded)="isDragging = false"
          class="lines-animation h-"
          [ngClass]="{
          'lines-vertical-spacing-inner': selectedBudgetType !== SPEND_TYPES.BUDGET
        }"
        >
          <app-budget-line-item
            class="form column lines-wrapper w-fit 2xl:w-auto"
            [item]="item"
            [minStartDate]="projectStartDate"
            [canDelete]="
            selectedBudgetType === SPEND_TYPES.BUDGET &&
            items.length > 1 &&
            !(hasCommitments$ | async) &&
            !userService.isPremiumSP
          "
          ></app-budget-line-item>

          @if ((selectedBudgetType === SPEND_TYPES.BUDGET_PARENT_CHILD ||
            selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS_GC) &&
          item.subitems?.length > 0) {
            <div
              cdkDropListOrientation="vertical"
              cdkDropListLockAxis="y"
              cdkDropList
              class="pb-0 lines-vertical-spacing"
              [ngClass]="{
              'cursor-grab': isDragging
            }"
              (cdkDropListDropped)="dropSubitem($event, item)"
            >
              @for (subitem of item.subitems; track subitem.id) {
                <div cdkDrag class="lines-vertical-spacing-inner lines-animation">
                  <app-budget-line-item
                    class="form column lines-wrapper w-fit 2xl:w-auto"
                    [item]="subitem"
                    [minStartDate]="projectStartDate"
                    [canDelete]="false"
                    [isSubItem]="true"
                  ></app-budget-line-item>

                  @if (selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS_GC &&
                  subitem?.committed_items?.length > 0) {
                    <div
                      cdkDropListOrientation="vertical"
                      cdkDropListLockAxis="y"
                      cdkDropList
                      class="lines-vertical-spacing-inner"
                      [ngClass]="{
                      'cursor-grab': isDragging
                    }"
                      (cdkDropListDropped)="dropCommittedItem($event, item)"
                    >
                      @for (commitedItem of subitem.committed_items; track commitedItem.id) {
                        <app-committed-line-item
                          class="form column lines-wrapper lines-animation w-fit 2xl:w-auto"
                          cdkDrag
                          (cdkDragStarted)="isDragging = true"
                          (cdkDragEnded)="isDragging = false"
                          [cdkDragDisabled]="commitedItem.type === 'forecast_modification'"
                          [committedItem]="commitedItem"
                          [lineItem]="item"
                          [minStartDate]="projectStartDate"
                        ></app-committed-line-item>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }

          @if (selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS) {
            <div
              cdkDropListOrientation="vertical"
              cdkDropListLockAxis="y"
              cdkDropList
              class="lines-vertical-spacing"
              [ngClass]="{
              'cursor-grab': isDragging
            }"
              (cdkDropListDropped)="dropCommittedItem($event, item)"
            >
              @for (commitedItem of item.committed_items; track commitedItem.id) {
                <app-committed-line-item
                  class="form column lines-wrapper lines-animation"
                  cdkDrag
                  (cdkDragStarted)="isDragging = true"
                  (cdkDragEnded)="isDragging = false"
                  [cdkDragDisabled]="commitedItem.type === 'forecast_modification'"
                  [committedItem]="commitedItem"
                  [lineItem]="item"
                  [minStartDate]="projectStartDate"
                ></app-committed-line-item>
              }
            </div>
          }
        </div>
      } @empty {
        <div
          class=" z-10 fixed top-64 w-full flex justify-center"
          [ngClass]="{
          'lines-vertical-spacing-inner': selectedBudgetType !== SPEND_TYPES.BUDGET
        }"
        >
          <div animate.enter="enter-animation" animate.leave="leave-animation" class=" text-size_3xl font-normal text-navy-700 text-center">
            There are no line items with data to display.<br/>
            Use the toggle below to include line items with zero values.
          </div>

          </div>
      }
    } @else if (selectedBudgetType === SPEND_TYPES.COMMITMENTS) {
      <div
        cdkDropListOrientation="vertical"
        cdkDropListLockAxis="y"
        cdkDropList
        cdkScrollable
        class="lines-vertical-spacing"
        [ngClass]="{
        'cursor-grab': isDragging
      }"
        (cdkDropListDropped)="dropCommittedItemOnly($event)"
      >
        @for (commitedItem of committedItems; track commitedItem.id) {
          <app-committed-line-item
            class="form column lines-wrapper lines-animation"
            cdkDrag
            [cdkDragDisabled]="commitedItem.type === 'forecast_modification'"
            (cdkDragStarted)="isDragging = true"
            (cdkDragEnded)="isDragging = false"
            [committedItem]="commitedItem"
            [lineItem]="commitedItem.lineItem"
            [minStartDate]="projectStartDate"
          ></app-committed-line-item>
        }
      </div>
    } @else if (selectedBudgetType === SPEND_TYPES.PRIME_CONTRACT_PARENT_ONLY ||
    selectedBudgetType === SPEND_TYPES.PRIME_CONTRACT_PARENT_CHILD) {
      @for (primeLine of primeLines; track primeLine.id) {
        <div
          cdkDrag
          (cdkDragStarted)="isDragging = true"
          (cdkDragEnded)="isDragging = false"
          class="lines-animation"
          [ngClass]="{
          'lines-vertical-spacing-inner': selectedBudgetType !== SPEND_TYPES.PRIME_CONTRACT_PARENT_ONLY
        }"
        >
          <app-prime-line-item
            class="form column lines-wrapper w-fit 2xl:w-auto"
            [item]="primeLine"
            [minStartDate]="projectStartDate"
            [canDelete]="false"
          ></app-prime-line-item>
          @if (selectedBudgetType === SPEND_TYPES.PRIME_CONTRACT_PARENT_CHILD && primeLine.subitems?.length > 0) {
            <div
              cdkDropListOrientation="vertical"
              cdkDropListLockAxis="y"
              cdkDropList
              class="pb-0 lines-vertical-spacing"
              [ngClass]="{
              'cursor-grab': isDragging
            }"
              (cdkDropListDropped)="dropSubitem($event, primeLine)"
            >
              @for (subitem of primeLine.subitems; track subitem.id) {
                <div cdkDrag class="lines-vertical-spacing-inner lines-animation">
                  <app-prime-line-item
                    class="form column lines-wrapper w-fit 2xl:w-auto"
                    [item]="subitem"
                    [minStartDate]="projectStartDate"
                    [canDelete]="false"
                    [isSubItem]="true"
                  ></app-prime-line-item>
                </div>
              }
            </div>


          }
        </div>
      }
    }

    <app-budget-line-item-totals
      [hideTotals]="
      !items.length ||
      selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS ||
      selectedBudgetType === SPEND_TYPES.BUDGET_COMMITMENTS_GC
    "
      [selectedBudgetType]="selectedBudgetType"
    ></app-budget-line-item-totals>
  </div>
</app-overlay-scrollbar>
